module.exports = __webpack_public_path__ + "static/media/S (200).45eacc96.jpg";